function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { Image as ImageComponent } from "@labs/schema";
import clsx from "clsx";
import React from "react";
export default function FullWidthImage(param) {
    var image = param.image, alt = param.alt, color = param.color;
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            backgroundColor: color
        },
        className: "my-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-0 block"
    }, /*#__PURE__*/ React.createElement("figure", {
        className: "relative block"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, image, {
        alt: alt,
        className: clsx("block w-full max-w-full")
    })))));
}
